import { ErrorInfo, ErrorCode } from "@/network/http";
import { requestData } from "./base";
import { PageReq, BaseReq, BaseRsp, GetInfoByIdReq } from "@/data/remote/base";
import { nullPageInfo } from "@/data/local/base";
import { 
    GetFaqListReq, 
    GetFaqListRsp,
    GetFaqDetailRsp
} from '@/data/remote/faq'
import { FaqList, FaqDetail } from '@/data/local/faq'

const URL_GET_FAQ_LIST = "/wxyj/faq/getFaqList";// 常见问题列表
const URL_GET_FAQ_DETAIL = "/wxyj/faq/getFaqDetail";//常见问题详情

export const getFaqList = (keyword: string, areaId: number, type: number, cat: number | null, pageNo: number, pageSize: number, callback?: (errorInfo: ErrorInfo, data: FaqList) => void) => {
    const payload: GetFaqListReq = {
        keyword,
        areaId,
        type,
        cat,
        pageNo,
        pageSize
    };

    requestData(URL_GET_FAQ_LIST, payload, (errorInfo: ErrorInfo, data: GetFaqListRsp) => {
        let rspData: FaqList = (errorInfo.errorCode === ErrorCode.SUCCESS) ? {
            list: [...data.list],
            pagination: {
                pageNo: data.pageNo,
                pageSize: data.pageSize,
                totalCount: data.totalCount,
                totalPage: data.totalPage
            }
        } : nullPageInfo;
        callback && callback(errorInfo, rspData);
    });
}

export const getFaqDetail = (id: number, callback?: (errorInfo: ErrorInfo, data: FaqDetail | null) => void) => {
    const payload: GetInfoByIdReq = {
        id
    };

    requestData(URL_GET_FAQ_DETAIL, payload, (errorInfo: ErrorInfo, data: GetFaqDetailRsp) => {
        let rspData: FaqDetail | null = (errorInfo.errorCode === ErrorCode.SUCCESS) ? {...data} : null;
        callback && callback(errorInfo, rspData);
    });
}